@if(isLoading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Buscando'"></app-loader>
  </div>
}

<div class="px-6 w-full space-y-5 mt-3">
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
    <div class="space-y-3">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Fechas</label>
        <app-datepicker (updateDates)="setDatesOnFilter($event)" [selectedFilterRange]="2"></app-datepicker>
      </div>
      <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div class="w-full sm:w-56">
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Vehículo</label>
          <p-select [options]="allDevices" [(ngModel)]="selectedCard" optionLabel="text" optionValue="value"
            [filter]="allDevices.length > 10" filterPlaceholder="Buscar..." class="w-full" />
        </div>
        <button pButton label="Buscar" icon="pi pi-search" class="p-button-sm w-full sm:w-auto" (click)="search()"></button>
      </div>
    </div>
  </div>

  @if(generatedCodes) {
    <app-custom-table [rowsByPage]="30" [headers]="headers" [elements]="generatedCodes"
      [actions]="[]" [hasButton]="false" [hasFilter]="true" [showStatus]="true" [statusList]="statusList"></app-custom-table>
  }
</div>
